import React from 'react'
import '../../App.css'
import Footer from '../Footer';
import AboutCC from '../AboutCC';
function Home(){
    return(
        <>
        <AboutCC/>
        <Footer />
        </>
    )
}
export default Home;